export enum Environment {
	TEST = 'TEST',
	LOCAL = 'LOCAL',
	DEVELOPMENT = 'DEVELOPMENT',
	STAGING = 'STAGING',
	PRODUCTION = 'PRODUCTION',
}
export type EnvironmentType = keyof typeof Environment;
